import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { Dropdown, MenuProps } from 'antd';
import { darkModeSelector } from 'features/app-info/selectors';
import { setDarkMode } from 'features/app-info/slice';
import { TOKEN } from 'features/auth/constants';
import { clearAuthToken, getAuthToken } from 'features/auth/helpers';
import { KEYCLOAK_CONFIG } from 'lib/keycloak/keycloak';
import { useAppDispatch, useAppSelector } from 'lib/stores/hook';
import { memo, useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getPath } from 'routes/router-paths';
import { routerUtils } from 'utils/utils';

const AppUserMenu = () => {
  routerUtils.navigate = useNavigate();
  routerUtils.location = useLocation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isDarkMode = useAppSelector(darkModeSelector);

  const userMenuItems = useMemo(
    (): MenuProps['items'] => [
      {
        label: (
          <div
            className="flex items-center gap-x-2"
            onClick={() => dispatch(setDarkMode(!isDarkMode))}
          >
            {!isDarkMode ? (
              <DarkModeIcon className="text-sm" />
            ) : (
              <LightModeIcon className="text-sm" />
            )}
            <p>{isDarkMode ? 'Light' : 'Dark'} mode</p>
          </div>
        ),
        key: 'darkMode',
      },
      {
        label: 'Đăng xuất',
        icon: <LogoutOutlinedIcon />,
        key: 'logout',
        danger: true,
      },
    ],
    [dispatch, isDarkMode]
  );

  const onUserMenuClick = useCallback(
    ({ key }: { key: string }): MenuProps['onClick'] => {
      if (key === 'darkMode') {
        return;
      }

      if (key !== 'logout') {
        navigate(key);
        return;
      }

      const token = getAuthToken(TOKEN.KC_TOKEN) as string;
      if (!token) {
        navigate(getPath('loginPage'));
        return;
      }

      const logoutUrl = new URL(
        `${KEYCLOAK_CONFIG.url}/realms/${KEYCLOAK_CONFIG.realm}/protocol/openid-connect/logout`
      );
      logoutUrl.searchParams.append('client_id', KEYCLOAK_CONFIG.clientId);
      logoutUrl.searchParams.append('id_token_hint', token);
      logoutUrl.searchParams.append(
        'post_logout_redirect_uri',
        `${window.location.origin}${getPath('loginPage')}`
      );

      clearAuthToken();

      window.location.href = logoutUrl.toString();
      return;
    },
    [navigate]
  );

  return (
    <Dropdown
      menu={{ items: userMenuItems, onClick: onUserMenuClick }}
      placement="bottomRight"
      overlayClassName="user-menu-dropdown"
      trigger={['click']}
    >
      <div className="cursor-pointer">
        <AccountCircleOutlinedIcon className="text-gray-500 dark:text-icon-dark" />
      </div>
    </Dropdown>
  );
};

export default memo(AppUserMenu);
